import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// ----------------------------------------------------------------------

export function useBack(fallback: string = '/'): () => void {
  const navigate = useNavigate();
  const location = useLocation();

  return useCallback(() => {
    let canGoBack = false;

    if (typeof window !== 'undefined') {
      const histState = window.history.state as { idx?: number } | null;
      const idx = histState?.idx;
      const { length } = window.history;

      if (typeof idx === 'number') {
        canGoBack = idx > 2;
      } else {
        canGoBack = length > 4;
      }
    }

    if (canGoBack) {
      navigate(-1);
    } else {
      if (location.pathname !== fallback) {
        navigate(fallback, { replace: true });
      }
    }
  }, [navigate, fallback, location.pathname]);
}
